import styled from "styled-components";
import { Link } from "react-router-dom";

const activeClassName = "active";

export const StyledHTMLLink = styled.a`
  &,
  &:visited,
  &:link {
    color: inherit;
    color: initial;
    text-decoration: none;
  }
`;

// .attrs({
//   activeClassName,
// })
// export const StyledRouterNavLink = styled(NavLink)`
//   &,
//   &:visited,
//   &:link {
//     color: inherit;
//     color: initial;
//     text-decoration: none;
//   }
// `;

// .attrs({
//   activeClassName,
// })
// &.${activeClassName} {
//   color: black;
// }

// 12/7 - Changed a tag to Link tag

// export const StyledRouterLink = styled.a`
export const StyledRouterLink = styled(Link)`
  &,
  &:visited,
  &:link {
    color: inherit;
    color: initial;
    text-decoration: none;
  }
`;
